<template>
  <div class="row">
    <div class="col s12">
      <div class="col s12 z-depth-1 white">
        <div class="row">
          <div class="left" style="padding-top: 10px;">
            <h5 class="title" style="padding-left: 11px;">{{ $t('analysis.complex') }}</h5>
          </div>
        </div>
            <div v-show="complexes.length > 0" class="col s12 z-depth-1 white">
              <div class="input-field">
                <ul class="horizontal-list filter-graph-list">
                  <li class="horizontal-list-item filter-graph-list-item" v-for="item in complexes" :key="item.id">
                    <label class="checkbox-small">
                    <input type="checkbox" name="dir_item.id" v-model="item.active"/>
                    <span class="checkbox-small body1">{{ item.name }}</span>
                  </label>
                  </li>
                </ul>
          </div>
          <button class="waves-effect waves-light btn buttonbg left" style="margin: 15px;" @click="getData">
              <i class="material-icons">refresh</i>
          </button>
          </div>
          <div class="col s12">
            <HighChart :options="chartOptions"/>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Chart } from 'highcharts-vue'
import SwitchApi from '../../../services/api/switch/SwitchApi'
import ComplexDataApi from '../../../services/api/ComplexDataApi'
import ComplexService from '../../../services/ComplexService'
import AssetsProvider from '@/providers/AssetsProvider'
import Highcharts from 'highcharts'

export default {
  name: 'ComplexAnalysis',
  components: {
    HighChart: Chart
  },
  props: {
    railObject: {
      required: true
    },
    complexObject: {
      required: true
    },
    timeSelection: {
      required: true
    }
  },
  data () {
    return {
      measurements: [],
      componentId: undefined,
      complexes: [],
      chartOptions: {
        chart: {
          zoomType: 'xy',
          zooming: {
            mouseWheel: {
              enabled: true
            }
          },
          events: {
            load () {
              const chart = this

              // Block scroll wheel unless Shift is held
              chart._wheelBlocker = (e) => {
                if (!e.shiftKey) {
                  if (e.stopImmediatePropagation) e.stopImmediatePropagation()
                  e.stopPropagation()
                }
              }
              chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

              // Show zoom cursor when Shift is held
              chart._cursorHint = (e) => {
                chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
              }
              chart.container.addEventListener('mousemove', chart._cursorHint)

              // Flip cursor immediately on Shift press/release
              chart._onKeyShift = (e) => {
                if (e.key === 'Shift' && chart.container) {
                  chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
                }
              }
              chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
              chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
            },
            destroy () {
              const el = this.container
              if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
              if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
              if (this._offKeyDown) this._offKeyDown()
              if (this._offKeyUp) this._offKeyUp()
            }
          }
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        accessibility: {
          enabled: false
        },
        subtitle: {
          text: ''
        },
        lang: {
          noData: this.$t('charts.nodata')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          title: {
            text: this.$t('analysis.datetime')
          },
          crosshair: {
            color: 'blue'
          },
          type: 'datetime',
          gridLineWidth: 1,
          dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%e %b \'%y',
            week: '%e %b \'%y',
            month: '%b \'%y',
            year: '%Y'
          }
        },
        yAxis: {
          type: 'category',
          title: {
            text: ''
          },
          gridLineWidth: 0,
          reversed: true,
          categories: {
          }
        },
        plotOptions: {
          scatter: {
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          }
        },
        tooltip: {
          formatter: function () {
            // return Highcharts.dateFormat('%e %b %Y %H:%M:%S', new Date(this.x)) + '<br/>'
            return moment(this.x).format('YYYY-MM-DD HH:mm:ss')
          },
          shared: true
        },
        series: [
          {
            name: 'datapoints',
            type: 'scatter',
            color: 'black',
            marker: {
              symbol: 'diamond'
            },
            data: [],
            turboThreshold: 0
          }
        ]
      },
      yCategories: []
    }
  },
  computed: {
  },
  methods: {
    setAssetComponent: async function (assets) {
      var asset = await assets.find(r => r.uniqueId === this.railObject.UniqueId)
      if (asset && asset.children) {
        this.componentId = asset.children[0].name
      }
    },
    getAssets: async function () {
      await AssetsProvider.getAssets().then(result => {
        this.setAssetComponent(result)
      })
    },
    getComplexes: function () {
      this.complexes = []
      if (this.complexObject.DepartmentId) {
        let tmp = ComplexService.getComplexesByDepartmentId(this.complexObject.DepartmentId)
        tmp.forEach(element => {
          if (element.ComplexId === this.complexObject.ComplexId) {
            this.complexes.push({ id: element.ComplexId, name: element.Name, active: true })
          } else {
            this.complexes.push({ id: element.ComplexId, name: element.Name, active: false })
          }
        })
      }
    },
    getData: async function () {
      this.measurements = []
      this.chartOptions.title.text = ''
      this.chartOptions.series[0].data = []
      if (this.complexObject && this.chartOptions) {
        let i = 0
        for (i in this.complexes) {
          if (this.complexes[i].active === true) {
            await ComplexDataApi.getComplexMeasurementData(
              this.complexes[i].id,
              moment(this.timeSelection.start).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
              moment(this.timeSelection.end).endOf('day').format('YYYY-MM-DDTHH:mm:ss'))
              .then(result => {
                this.measurements = this.measurements.concat(result.data)
              })
            await SwitchApi.getComplexMeasurementData(
              this.complexes[i].id,
              moment(this.timeSelection.start).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
              moment(this.timeSelection.end).endOf('day').format('YYYY-MM-DDTHH:mm:ss'))
              .then(result => {
                if (this.chartOptions.title.text === '') {
                  this.chartOptions.title.text = this.chartOptions.title.text.concat(this.complexes[i].name)
                } else {
                  this.chartOptions.title.text = this.chartOptions.title.text.concat(', ')
                  this.chartOptions.title.text = this.chartOptions.title.text.concat(this.complexes[i].name)
                }

                if (result.data !== null) {
                  this.measurements = this.measurements.concat(result.data)
                }
                this.yCategories = [...new Set(this.measurements.map(m => m.RailObjectName))]
                this.chartOptions.yAxis.categories = this.yCategories
                this.chartOptions.series[0].data = this.measurements.map(x => ({
                  x: Date.parse(x.MeasurementDateTime),
                  y: this.yCategories.indexOf(x.RailObjectName),
                  name: x.RailObjectName,
                  color: this.getColor(x.SeverityId),
                  marker: {
                    fillColor: this.getColor(x.SeverityId)
                  }
                }))
              })
          }
        }
      }
    },
    getColor (severityId) {
      let result = 'black'
      switch (severityId) {
        case 0:
        case 1:
          result = 'black'
          break
        case 2:
          result = 'orange'
          break
        case 3:
          result = 'red'
          break
        default:
          result = 'green'
      }
      return result
    }
  },
  created: async function () {
    if (this.complexObject) {
      await this.getComplexes()
      await this.getData()
      await this.getAssets()
    }
  },
  watch: {
    complexObject: async function (val) {
      await this.getData()
    },
    railObject: async function (val) {
      await this.getData()
    },
    timeSelection: async function () {
      await this.getData()
    }
  }
}
</script>

<style scoped>
  .horizontal-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .horizontal-list-item {
    display: inline-block;
  }

  .filter-graph-list {
    display: inline-block;
  }

  .filter-graph-list-item {
    padding-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/analysis/ComplexAnalysis.vue